import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {Constants} from "../../services/constants";
import {ProfilesService} from "../../services/profiles.service";
import {SharedService} from "../../services/shared.service";
import {HttpApiService} from "../../services/http-api.service";
import {EndpointsService} from "../../services/endpoints.service";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls:['./home.component.scss']
})
export class HomeComponent implements OnInit {

  profiles: any;
  reseller: any = {};
  isMothershipTenant: boolean = Constants.IS_MOTHERSHIP_TENANT();

  private bucketUrl: string = Constants.BUCKET_URL();
  private domain: string = Constants.TENANT_ID();
  private tenantBucket: string = Constants.TENANT_BUCKET();

  constructor(private Api: HttpApiService,
              private endpoints: EndpointsService,
              private profileService: ProfilesService,
              private sharedService: SharedService,
              private router: Router) {
    if (this.isMothershipTenant && !this.router.navigated) {
      this.router.navigateByUrl("/");
      return;
    }
    this.isMothershipTenant=false;
    this.profileService.subscribeForProfiles().subscribe(data => {
      this.profiles = data;
    });
    this.profileService.getProfiles();
  }

  ngOnInit(): void {
    this.Api.get(this.endpoints.getResellerByDomainUrl(`domain=${this.domain}`))
      .subscribe(response => {
        this.reseller = response;
      },
      error => {
        console.log(error);
      });
  }

  navigateToProfile(profile: any) {
    this.sharedService.navigateToProfile(profile, this.router);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/home/home.component.ts